import styled from '@emotion/styled';
import {Button} from '@mui/material';

export const DocumentPagination = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px;
  border-radius: 8px;
  // box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  margin-right: 5rem;
`;

export const IconButtonWrapper = styled(Button)<{
  bgcolor?: string;
}>`
  border-radius: 50%;
  min-width: 30px;
  width: 30px !important;
  height: 30px !important;
  padding: 0;
  margin-right: 8px;
  background-color: ${({bgcolor}) => (bgcolor ? bgcolor : '#f5f5f5')};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);

  .MuiSvgIcon-root {
    width: 24px;
    height: 24px;
    margin: auto;
    display: block;
  }
`;
